import { rgba } from 'polished';
import themed from '../themed';


export const B = '#000000';
export const W = '#FFFFFF';

// Pelēks
export const B87 = '#212121';
export const B72 = '#484848';
export const B54 = '#757575';
export const B38 = '#9E9E9E';
export const B26 = '#BDBDBD';
export const B12 = '#E0E0E0';

export const B87A = 'rgba(0, 0, 0, 0.87)';
export const B72A = 'rgba(0, 0, 0, 0.72)';
export const B54A = 'rgba(0, 0, 0, 0.54)';
export const B38A = 'rgba(0, 0, 0, 0.38)';
export const B26A = 'rgba(0, 0, 0, 0.26)';
export const B12A = 'rgba(0, 0, 0, 0.12)';

// Primārā
export const P = '#00838F';
export const PL = '#4FB3BF';
export const PD = '#005662';
export const PA = rgba(P, 0.12);

// Sekundārā
export const S = '#EF5350';
export const SL = '#E57373';
export const SD = '#D32F2F';
export const SA = rgba(S, 0.12);

// Statuss
export const ERROR = '#EC4343';
export const SUCC = '#EC4343';
export const WARN = '#FFBF47';

// Cits
export const BORDER = '#E0E0E0';
export const HIGHLIGHT = '#F5F5F5';
// NOTE: :focus variants
export const FOCUS = WARN;
// NOTE: a:visited variants
export const VISIT = '#2E0160';
// NOTE: Vājredzīgo dzeltens
export const Y = '#F9F300';


export const lightThemed = {
  light: W,
  dark: B,
  blackOnYellow: Y,
  yellowOnBlack: B,
};

export const darkThemed = {
  light: B,
  dark: W,
  blackOnYellow: B,
  yellowOnBlack: Y,
};


export const background = themed(lightThemed);
export const black = themed(darkThemed);

export const hairline = themed(
  Object.assign({}, darkThemed, {
    light: B12
  })
);

export const text = themed(
  Object.assign({}, darkThemed, {
    light: B87
  })
);

export const visited = themed(
  Object.assign({}, darkThemed, {
    light: '#1B096B',
  })
);

export const subtleText = themed(
  Object.assign({}, darkThemed, {
    light: B72
  })
);

export const lightText = themed(
  Object.assign({}, darkThemed, {
    light: B54
  })
);

export const focus = themed(
  Object.assign({}, darkThemed, {
    light: FOCUS
  })
);

export const highlight = themed(
  Object.assign({}, lightThemed, {
    light: HIGHLIGHT
  })
);

export const disabled = B26;


export const primary = themed(
  Object.assign({}, darkThemed, {
    light: P
  })
);
export const primaryLight = themed(
  Object.assign({}, darkThemed, {
    light: PL
  })
);
export const primaryDark = themed(
  Object.assign({}, darkThemed, {
    light: PD
  })
);

export const secondary = themed(
  Object.assign({}, darkThemed, {
    light: S
  })
);
export const secondaryLight = themed(
  Object.assign({}, darkThemed, {
    light: SL
  })
);
export const secondaryDark = themed(
  Object.assign({}, darkThemed, {
    light: SD
  })
);


export const accent = (props, variation) => {
  const {accent} = props;
  const sec = (
    accent && (accent === 'secondary')
  );
  switch (variation) {
    case 'light':
      return sec ? secondaryLight : primaryLight;
    case 'dark':
      return sec ? secondaryDark : primaryDark;
    default:
      return sec ? secondary : primary;
  }
}



// WEBPACK FOOTER //
// ./src/core/theme/components/colors.js